export const facebook = 'https://www.facebook.com/beton.ukraine'
export const instagram = 'https://www.instagram.com/beton.ukraine'
export const telegram = 'https://t.me/+ekNQ5xpqXdwxYTIy'
export const viber = 'https://invite.viber.com/?g2=AQBPmu8FJYAkFFL3xr0QgLKb%2F9YPTbfj1soqjfMcQMl%2BhJO6zRwJiXjZ3buPOqXx'
export const linkBrand = 'beton.ua'
export const telephone = '+380633822233'
export const suportMail = 'support@beton.ua'
export const nameBrand = 'BETON'

// export const nameCasino = 'BETON Casino'
export const nameCasino = 'BETON'

export const nameApp = 'BETON APP'
export const address = {
  '@type': 'PostalAddress',
  'streetAddress': 'вул. Воздвиженська, будинок 45-47-49, офіс 208',
  'addressLocality': 'м. Київ',
  'postalCode': '04071',
  'addressCountry': 'UA',
}
